import React from 'react';
import { Form, Label, Segment } from 'semantic-ui-react';

const Coverage = props => (
    <Segment>
        <Form.Group>
            <Form.Field>
                <Label color='green' ribbon>Enter the Coverage ID</Label>
                <Form.Input disabled={props.readOnlyMode} placeholder='Coverage ID' name='coverageId' value={props.coverageId} onChange={props.onCoverageIdChange} maxLength='10' fluid />
            </Form.Field>
        </Form.Group>
    </Segment>

);

export default Coverage;